import React, { Fragment, useContext, useRef, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import translations from "../../../components/common/Translations";
import AppContext from "../../../context/AppContext";
import { FaPlusCircle } from "react-icons/fa";
import { toast } from "../../../utils/toast";
import CommonButton from "../../../components/common/CommonButton";
import ModalCloseButton from "../../../components/common/ModalCloseButton";

export const GetFieldFolder = ({
  open,
  setOpen,
  fields,
  setFields,
  taskExcelColumns,
  setTaskExcelColumns,
}) => {
  const cancelButtonRef = useRef(null);
  const { theme , langMode } = useContext(AppContext);

  const handleCheckboxChange = (taskDetailsMetadataId) => {
    setFields((prevFields) =>
      prevFields.map((field) =>
        field.taskDetailsMetadataId === taskDetailsMetadataId
          ? { ...field, isReport: !field.isReport }
          : field
      )
    );
  };
  const handleAddClick = () => {
    const updatedFields = fields.map((field) => ({
      ...field,
      isReport: field.isReport,
    }));
    setTaskExcelColumns(updatedFields); 
    setOpen(false); // Close modal
    localStorage.setItem("selectedFields", JSON.stringify(updatedFields)); // Save to localStorage
    toast.warn(translations[langMode].updatetheworkflow);
    console.log(updatedFields);
  };

  // Lock background page scroll while this modal is open, so only the modal's
  // own field-list scrolls -- avoids two visible scrollbars stacked together.
  useEffect(() => {
    if (!open) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [open]);

  useEffect(() => {
    if (open) {
      const savedFields = localStorage.getItem("selectedFields");
      if (savedFields) {
        const parsedFields = JSON.parse(savedFields);
        setFields((prevFields) =>
          prevFields.map((field) => {
            const savedField = parsedFields.find(
              (f) => f.taskDetailsMetadataId === field.taskDetailsMetadataId
            );
            return savedField ? { ...field, isReport: savedField.isReport } : field;
          })
        );
      }
    }
  }, [open, setFields]);


  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        initialFocus={cancelButtonRef}
        onClose={() => setOpen(false)}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            className={`fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity`}
          />
        </Transition.Child>
        <div className="fixed inset-0 z-50 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
              <Dialog.Panel
                className={`relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg ${
                  theme === "dark"
                    ? "dark-mode"
                    : theme === "high-contrast"
                    ? "high-contrast"
                    : ""
                }`}  >
                <div
                  className={`bg-white rounded-lg shadow ${
                    theme === "dark"
                      ? "dark-mode"
                      : theme === "high-contrast"
                      ? "high-contrast"
                      : "" }`} >
                  <div className="flex items-center justify-between p-2 md:p-5 rounded-t dark:border-gray-600">
                    <h3 className="text-sm font-semibold text-gray-900 dark:text-white">
                      {translations[langMode].addfield}
                    </h3>
                    <ModalCloseButton
                      onClick={() => setOpen(false)}
                      ariaLabel="Close modal"
                    />
                  </div>
                  <div className="px-5 grid grid-cols-2 gap-5 h-auto max-h-[300px] overflow-y-auto">
                    {fields.map((field) => (
                      <div
                        key={field.taskDetailsMetadataId}
                        className="flex items-center" >
                        <input
                          type="checkbox"
                          id={`field-${field.taskDetailsMetadataId}`}
                          checked={field.isReport}
                          onChange={() =>
                            handleCheckboxChange(field.taskDetailsMetadataId)
                          }
                          className="mr-2"
                        />
                        <label
                          htmlFor={`field-${field.taskDetailsMetadataId}`}
                          className="text-sm text-gray-900 dark:text-white"   >
                          {field.fieldName}
                        </label>
                      </div>
                    ))}
                  </div>
                  <div className="p-5 flex justify-end rtl:justify-start">
                    <CommonButton colorIntent="primary"
                      variant="primary"
                      tooltipText={'Add selected fields to report'}
                      tooltipPosition="right"
                      type="button"
                      onClick={handleAddClick}
                      >
                     <FaPlusCircle size={14}/> Add Field
                    </CommonButton>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};
